
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/helping-juniors",
      function () {
        return require("private-next-pages/helping-juniors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/helping-juniors"])
      });
    }
  